module.exports = __webpack_public_path__ + "static/media/gmulogo.edec07d3.jpg";